import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserUrl } from '../../../shared/urls/user.url';
import { BookingUrl } from '../../../shared/urls/booking.url';
@Injectable()
export class RequestAppointmentService {
  constructor(
    public baseService: BaseService) { }

  getUserCountryList() {
    const url = UserUrl.GET_USER_COUNTRY;
    return this.baseService.getData(url);
  }

  getInit() {
    const url = BookingUrl.GET_BOOKING_INIT;
    return this.baseService.getData(url);
  }

  addBooking(param) {
    const url = BookingUrl.ADD_BOOKING;
    return this.baseService.postData(url, param);
  }

  getBookingCache() {
    const url = BookingUrl.GET_BOOKING_CACHE;
    return this.baseService.getData(url);
  }

  addBookingCache(param) {
    const url = BookingUrl.ADD_BOOKING_CACHE;
    return this.baseService.postData(url, param);
  }

  validateDateRange(fromDateControl, toDateControl, isFromDateActive) {
    if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
      return;
    }
    // validate fromDate < toDate
    if (ValidationService.compareDate(fromDateControl, toDateControl) === 1) {
      if (isFromDateActive) {
        fromDateControl.setErrors({ 'invalidDateRangeBooking': true });
      } else {
        toDateControl.setErrors({ 'invalidDateRangeBooking': true });
      }

    } else {
      fromDateControl.setErrors(null);
      toDateControl.setErrors(null);
      // validate The date range must bbe within 6 months
      // const rangeMonth = new Date(fromDateControl.value);
      // rangeMonth.setMonth(fromDateControl.value.getMonth() + 6);
      // rangeMonth.setHours(0, 0, 0);
      // if (rangeMonth.getTime() < toDateControl.value.getTime()) {
      //   if (isFromDateActive) {
      //     fromDateControl.setErrors({ 'invalidMonthRangeWaitingRoom': true });
      //   } else {
      //     toDateControl.setErrors({ 'invalidMonthRangeWaitingRoom': true });
      //   }
      // }
    }

  }
  getAllClinic(selectedCentre){
    const url = BookingUrl.GET_ALL_CENTRE_CLINC;
    return this.baseService.getData(url, selectedCentre);
  }
  getAllReason(){
    const url = BookingUrl.GET_ALL_REASON;
    return this.baseService.getAll(url);
  }

  getDisableList() {
    return [
      'travelDestination',
      'typeAccommodation',
      'listMembers',
      'reasonTrip',
      'depDate',
      'departDate',
      'reDate',
      'returnDate',
      'typeAccommodation',
      'travelDestination',
      'reasonTrip',
      'reasonId',
      'groupName',
      'paymentTerm',
      'listMembers',
      'destination',
      'administeredDate',
      'adminDate',
      'duration',
      'fromTime',
      'toTime',
      'startHour',
      'startMinutes',
      'endHour',
      'isChangeType'
    ];
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/request-appointment/request-appointment.service.ts